import styled from "styled-components";
import { Card } from "react-bootstrap";
import { colors, types } from "../../../../../libs";

export const ListContainer = styled.div`
  margin-top: 20px;
`;

export const CampaignCard = styled(Card)`
  background: ${colors.background.formField};  
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px; 
  color: ${colors.text.white};
  cursor: pointer;
`;

export const CampaignHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ActionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const CampaignTitle = styled.h5`
  ${types.headers.small};
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
`;

export const VideoText = styled.span`
  ${types.headers.small};
  color: ${colors.background.green};  
  font-weight: 600;
`;

export const Categories = styled.p`
  ${types.body.subtitle};
  ${types.body.normal};
  color: rgba(255, 255, 255, 0.7);
  margin-top: 5px;
`;

export const ArrowIcon = styled.img`
  width: auto;
  height: 16px;
`;

export const DeleteIcon = styled.img`
  cursor: pointer;
  width: 32px;
  height: 32px;
`;

export const ConfirmModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  z-index: 9999; /* Ensure it appears on top */
`;
